export default {
  userResult: null,
};
